import Header from '../../../components/Header';
import Slide1 from './images/1.png';
import Slide2 from './images/2.png';
import Slide3 from './images/3.png';
import Slide4 from './images/4.png';
import Slide5 from './images/5.png';
import Slide6 from './images/6.png';
import Slide7 from './images/7.png';

const MajorProjectPage = () => {
  return (
    <div className='min-h-screen text-white flex flex-col items-center pattern' style={{ backgroundColor: '#111' }}>
      <Header />

      <div className=''>
        <img src={Slide1} className='' alt='logo' />
        <img src={Slide2} className='' alt='logo' />
        <img src={Slide3} className='' alt='logo' />
        <img src={Slide4} className='' alt='logo' />
        <img src={Slide5} className='' alt='logo' />
        <img src={Slide6} className='' alt='logo' />
        <img src={Slide7} className='' alt='logo' />
      </div>
    </div>
  );
}
export default MajorProjectPage;
